import { asCatalog } from './contract';
import { plannerApproveKeywords } from './commands/plannerApproveKeywords';
import { plannerFindKeywords } from './commands/plannerFindKeywords';
import { plannerScheduleWpPublish, plannerSetCalendarDate } from './commands/plannerCalendar';
import { bbSetVoiceSummary } from './commands/brandBible';
import {
  plannerCreateArticle,
  plannerFindArticles,
  plannerPublishArticles,
  plannerRestartGeneration,
} from './commands/plannerTable';
import { edToggleBold, edToggleItalic } from './commands/editorFormatting';
import { edReadSelection } from './commands/editorSelection';
import { edSaveDraft, edPublishCms } from './commands/editorDocument';
import { edSetCanonical, edSetJsonld, edSetOgImage } from './commands/editorMetadata';

/**
 * Append-only. Each lane adds its own commands; conflicts here are trivial to
 * resolve because the array is the whole edit.
 *
 * Reads first: an agent holding no ids can only start from a list tool, so the
 * order mirrors the id chain rather than the lane that landed first.
 */
export const CATALOG = asCatalog([
  plannerFindKeywords,
  plannerFindArticles,
  plannerApproveKeywords,
  plannerSetCalendarDate,
  plannerScheduleWpPublish,
  plannerCreateArticle,
  plannerPublishArticles,
  plannerRestartGeneration,
  bbSetVoiceSummary,
  // Editor — toolbar, canvas, rail
  edToggleBold,
  edToggleItalic,
  edReadSelection,
  edSaveDraft,
  edSetCanonical,
  edSetJsonld,
  edSetOgImage,
  edPublishCms,
]);
